// extracted by mini-css-extract-plugin
export default {"largeInput":"CiteMenu_largeInput__0qXSp","list":"CiteMenu_list__LNQAI","mantine-combobox-option":"CiteMenu_mantine-combobox-option__VrPcc","input":"CiteMenu_input__ypQ53"};